import { create } from 'zustand';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export interface Toast {
  id: string;
  message: string;
  type: ToastType;
  duration: number;
}

interface ToastState {
  toasts: Toast[];
  addToast: (toast: Omit<Toast, 'id'>) => void;
  removeToast: (id: string) => void;
  success: (message: string, duration?: number) => void;
  error: (message: string, duration?: number) => void;
  warning: (message: string, duration?: number) => void;
  info: (message: string, duration?: number) => void;
}

const MAX_TOASTS = 5;

let toastCounter = 0;

export const useToastStore = create<ToastState>((set, get) => ({
  toasts: [],

  addToast: (toast) => {
    const id = `toast-${++toastCounter}`;
    set((state) => ({
      toasts: [...state.toasts.slice(-(MAX_TOASTS - 1)), { ...toast, id }],
    }));
    // Auto-remove
    setTimeout(() => get().removeToast(id), toast.duration);
  },

  removeToast: (id) => {
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    }));
  },

  success: (message, duration = 4000) =>
    get().addToast({ message, type: 'success', duration }),
  error: (message, duration = 4000) =>
    get().addToast({ message, type: 'error', duration }),
  warning: (message, duration = 4000) =>
    get().addToast({ message, type: 'warning', duration }),
  info: (message, duration = 4000) =>
    get().addToast({ message, type: 'info', duration }),
}));
